import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  const columnsToValidateDuplication = [
    {columns: config.featureColumns, messagePrefix: 'Cannot use a column as a feature more than once.'},
    {columns: config.excludedColumns, messagePrefix: 'Cannot exclude a column more than once.'},
    {
      columns: config.metadataColumns,
      messagePrefix: 'Cannot use a column as metadata more than once.',
    },
  ];

  const duplicateColumnsMessages = columnsToValidateDuplication.map((data) =>
    Helpers.getDuplicateColumnsMessage(dataFrameSpec, data.columns, data.messagePrefix)
  );

  const featuresAndExcludeBothSetMessage =
    config.featureColumns.length > 0 && config.excludedColumns.length > 0
      ? 'Feature columns and Columns to exclude cannot be set at the same time.'
      : null;

  const columnsToValidateOverlap = [
    {
      columns1: config.featureColumns,
      columns2: config.metadataColumns,
      messagePrefix: 'Cannot both use a column as a feature and as metadata.',
    },
    {
      columns1: config.excludedColumns,
      columns2: config.metadataColumns,
      messagePrefix: 'Cannot both use a column as metadata and exclude it.',
    },
    {
      columns1: config.excludedColumns,
      columns2: config.groupingColumn ? [config.labelColumn, config.groupingColumn] : [config.labelColumn],
      messagePrefix: 'Cannot exclude a column if it is used as the Y variable or Grouping column.',
    },
    {
      columns1: config.featureColumns,
      columns2: config.groupingColumn ? [config.labelColumn, config.groupingColumn] : [config.labelColumn],
      messagePrefix:
        'Cannot set a column as feature column if it is used as the Y variable or Grouping column.',
    },
  ];

  const overlappedColumnsMessages = columnsToValidateOverlap.map((data) =>
    Helpers.getOverlappedColumnsMessage(dataFrameSpec, data.columns1, data.columns2, data.messagePrefix)
  );

  return Helpers.coalesceMessages(
    duplicateColumnsMessages,
    featuresAndExcludeBothSetMessage,
    overlappedColumnsMessages
  );
};

export default {
  stepType: PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION, 0>;
